export default __webpack_public_path__ + "static/media/state.notfound.08e0b0b2.svg";